module.exports = __webpack_public_path__ + "img/ico-search-focus.dda32ac9.svg";